/*
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { warningAlert } from './action/warningAlert';
import { criterion } from './action/criterion';
import { gasLog } from './action/gasLog';
import { moduleGroups } from './action/moduleGroups';
import { modules } from './action/modules';
import { auths } from './action/auths';
import { settings } from './action/settings';
import { warningLogs } from './action/warningLog';
import { menus } from './action/menus';
import { loginManager } from './action/login';
import { mainSetting1 } from './action/mainSetting1';
export default (history) =>
  combineReducers({
    router: connectRouter(history),
    criterion,
    gasLog,
    moduleGroups,
    modules,
    auths,
    settings,
    warningLogs,
    menus,
    warningAlert,
    loginManager,
    mainSetting1,
  });
